import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { IMessageHelperProps } from './_props';

import useInputMessageHelperTheme from './themes';

/**
 * MessageHelper Component
 */

function MessageHelper({ message, state, theme }: IMessageHelperProps) {
  const { messageHelperTextStateThemeClasses, messageHelperTextThemeClasses } = useInputMessageHelperTheme({
    inputTheme: theme,
    inputState: state,
  });

  if (!message) return null;

  return (
    <span className={twMerge(messageHelperTextStateThemeClasses, messageHelperTextThemeClasses)}>{message}</span>
  );
}

export default MessageHelper;
